import { z } from "zod";

/**
 * DFT-0084: EXEMPTED-only direct-approve payload. dateFromApproved/dateToApproved are seeded
 * silently from the request's own dateFrom/dateTo (mirroring PreApproveDialog's own hidden-dates
 * pattern, Megaplan 2026-08-05 - Operations approves the vendor's requested window as-is, no
 * visible date fields). No totalAmount field at all - EXEMPTED is never chargeable.
 */
export const APPROVE_EXEMPTED_DIALOG_FIELDS = {
  DATE_FROM_APPROVED: "dateFromApproved",
  DATE_TO_APPROVED: "dateToApproved",
  PRE_APPROVAL_REMARKS: "preApprovalRemarks",
} as const;

export const approveExemptedDialogSchema = z
  .object({
    dateFromApproved: z.string().min(1, "Date from is required"),
    dateToApproved: z.string().min(1, "Date to is required"),
    // DFT-0078 precedent: same 1000-char bound preApproveDialogSchema's own remarks field uses.
    preApprovalRemarks: z
      .string()
      .max(1000, "Remarks must be 1000 characters or fewer.")
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.dateFromApproved &&
      data.dateToApproved &&
      data.dateToApproved < data.dateFromApproved
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["dateToApproved"],
        message: "Date to must be on or after date from",
      });
    }
  });

export type ApproveExemptedDialogFormData = z.infer<typeof approveExemptedDialogSchema>;

export const approveExemptedDialogDefaultValues: ApproveExemptedDialogFormData = {
  dateFromApproved: "",
  dateToApproved: "",
  preApprovalRemarks: "",
};
